import { Link, NavLink } from 'react-router-dom';
import Header from './header';
import { cn } from '@/lib/utils';
import {
  navConsole,
  navConsoleFooter,
  navConsoleFrist,
  NavItems,
} from './navigation/configNav';

import React, { ReactElement } from 'react';
import { isEmpty } from '@/utils';

import { Separator } from '../ui/separator';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import NavigationIconLink from './navigation/NavigationIconLink';
import { useAppState } from '@/store/app-state';
import { Logo } from '../ui/icons';
import siteConfig from '@/config';
import ConsoleLayoutNavbar from './ConsoleLayoutNavbar';
import GlobalAlertInActive from '../global/GlobalAlertInActive';

type ConsoleLayoutProps = {
  title?: string;
  navbar?: NavItems;
  children: React.ReactNode;
  navbarFooter?: React.ReactNode;
  isSidebar?: boolean;
};
const ConsoleLayout = ({
  title,
  navbar = [],
  navbarFooter,
  children,
  isSidebar = true,
}: ConsoleLayoutProps) => {
  const childrenArray = React.Children.toArray(children) as ReactElement[];
  const bar = childrenArray.find(
    (child) => child.type === ConsoleLayout.Navbar
  );
  const content = childrenArray.filter(
    (child) => child.type !== ConsoleLayout.Navbar
  );
  const { consoleLayoutConfig } = useAppState();
  const { navConfig } = consoleLayoutConfig;
  return (
    <div>
      <div className="h-screen min-h-[0px] flex-1 basis-0">
        <div className={cn('flex h-full')}>
          {isSidebar && <Side />}
          <div className="flex w-full">
            {bar ? bar : <></>}
            <ConsoleLayoutNavbar
              navbar={isEmpty(navbar) ? navConfig.navbar : navbar}
              navbarFooter={
                isEmpty(navbarFooter) ? navConfig.navbarFooter : navbarFooter
              }
              title={isEmpty(title) ? navConfig.title : title}
            />
            <div className="flex w-full flex-col">
              <header className="sticky top-0 z-10 flex max-h-[var(--header-height)] min-h-[var(--header-height)] w-full items-center gap-4 border-b bg-background-sidebar px-4 md:px-6">
                <Header />
              </header>
              <GlobalAlertInActive />
              <div className="relative overflow-auto pb-8">{content}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ConsoleLayout.Navbar = (props: {
  title?: string;
  navbar?: NavItems;
  navbarFooter?: React.ReactNode;
}) => (
  <>
    <ConsoleLayoutNavbar {...props} />
  </>
);

export default ConsoleLayout;

const Side = () => {
  const { workspaceId } = useParamWorkspaceId();
  const { navigationPanelOpen, setNavigationPanelOpen } = useAppState();
  const { services } = siteConfig;

  const onCloseNavigationIconLink = (event: any) =>
    setNavigationPanelOpen(
      false,
      event.target.id === 'icon-link' ||
        ['svg', 'path'].includes(event.target.localName)
    );

  return (
    <div className="flex h-full w-14 flex-col">
      <nav
        className={cn(
          'group z-10 h-full w-14 py-2 data-[state=expanded]:w-[16rem]',
          'border-r bg-background-sidebar data-[state=expanded]:shadow-xl',
          'transition-width duration-200',
          'hide-scrollbar flex flex-col justify-between',
          'overflow-y-auto',
          'font-medium'
        )}
        data-state={navigationPanelOpen ? 'expanded' : 'collapsed'}
        onMouseEnter={() => setNavigationPanelOpen(true)}
        onMouseLeave={() => setNavigationPanelOpen(false)}
      >
        <ul className="relative flex flex-col justify-start gap-y-2 px-2">
          <div className="h-[var(--header-height)]">
            <Link
              to="/"
              className="flex items-center justify-start"
              onClick={onCloseNavigationIconLink}
            >
              <Logo className="h-[36px] w-[36px]" />
              <span className="sr-only">Float16</span>
            </Link>
          </div>
          {navConsoleFrist(workspaceId).map((item, index) => (
            <NavigationIconLink
              key={index}
              route={item}
              onClick={onCloseNavigationIconLink}
            />
          ))}
          <Separator />
          {navConsole(workspaceId)
            .filter((item) => !item.isHidden)
            .map((item, index) => (
              <NavigationIconLink
                key={index}
                route={item}
                onClick={onCloseNavigationIconLink}
              />
            ))}
        </ul>
        <ul className="flex flex-col gap-y-1 px-2">
          {navConsoleFooter(workspaceId).map((item, index) => (
            <NavigationIconLink
              key={index}
              route={item}
              onClick={onCloseNavigationIconLink}
            />
          ))}
        </ul>
      </nav>
    </div>
  );
};
